var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDsptchLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9 4.09961H0L4.8 12.4996L0 20.8996H3.9L8.4 12.4996L3.9 4.09961Z",
    fill: "#5C697B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9 4.09961H0L4.8 12.4996L3.6 14.5996L5.5701 17.7821L8.4 12.4996L3.9 4.09961ZM7.2 4.09961H13.8C13.8 4.09961 17.3143 4.09961 20.4 6.49961C23.0182 8.53601 24 12.4996 24 12.4996C24 12.4996 23.4 16.0996 20.4 18.4996C17.4 20.8996 13.8 20.8996 13.8 20.8996H6.6V17.5996H14.4C14.4 17.5996 16.1186 17.5996 18 16.0996C20.1 14.4253 20.7 12.4996 20.7 12.4996C20.7 12.4996 19.9014 10.3996 18 8.89961C15.8434 7.19831 13.8 7.39961 13.8 7.39961H7.2V4.09961Z",
    fill: "#8697AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50039 4.09961H3.90039L8.40039 12.4996L3.90039 20.8996H7.50039L12.3004 12.4996L7.50039 4.09961Z",
    fill: "#E9EBF4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50039 4.09961H3.90039L8.40039 12.4996L3.90039 20.8996H7.50039L12.3004 12.4996L7.50039 4.09961Z",
    fill: "#E9EBF4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.90039 4.09961H7.50039L12.3004 12.4996L7.50039 20.8996L5.57049 17.7821L8.40039 12.4996L3.90039 4.09961Z",
    fill: "#C3CCD9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsptchLogo);
export default __webpack_public_path__ + "static/media/DSPTCH_logo.3ea1dc921b87421c6356598fd502a800.svg";
export { ForwardRef as ReactComponent };